import { Suspense } from 'react';
import { Navigate, Outlet, Route, Routes } from 'react-router-dom';

import { DigitalCampaignsPage } from '~/modules/artist-roster/pages/artist-details/pages/digital-campaigns/DigitalCampaignsPage';
import { MediaPlannerPage } from '~/modules/artist-roster/pages/artist-details/pages/media-planner/MediaPlannerPage';
import { RosterPage } from '~/modules/artist-roster/pages/roster/RosterPage';
import { E2eArtistPage } from '~/modules/artist-roster/pages/testing/E2eArtistPage';
import { FEATURE_FLAGS } from '~/modules/experiments/features';
import { useFeatureFlags } from '~/modules/experiments/hooks/useFeatureFlags';

import { ArtistDetailsPage } from '../pages/artist-details/ArtistDetailsPage';
import { ArtistBenchmarksPage } from '../pages/artist-details/pages/artist-benchmarks/ArtistBenchmarksPage';
import { ArtistPreReleasesPage } from '../pages/artist-details/pages/artist-pre-releases/ArtistPreReleasesPage';
import { ArtistTracksPage } from '../pages/artist-details/pages/artist-tracks/ArtistTracksPage';
import { TrackDetailsPage } from '../pages/track-details/TrackDetailsPage';

/**
 * Top-level router combining module-level routers
 */
export function Router() {
  const [isDigitalCampaignsMediaPlanningEnabled] = useFeatureFlags([
    FEATURE_FLAGS.WmgDigitalCampaignsMediaPlanningEnabled,
  ]);

  const CampaignsPage = isDigitalCampaignsMediaPlanningEnabled
    ? DigitalCampaignsPage
    : ArtistBenchmarksPage;

  return (
    <Suspense>
      <Routes>
        <Route element={<Outlet />}>
          <Route path="*" element={<RosterPage />} />
          {/* @TODO WMG1-736 - Remove this route once we've finished debugging the e2e tests.*/}
          <Route path="e2e/artist-page" element={<E2eArtistPage />} />
          <Route path=":partyId" element={<ArtistDetailsPage />}>
            <Route index element={<Navigate to="tracks" replace />} />
            <Route path="tracks" element={<ArtistTracksPage />} />
            <Route path="pre-releases" element={<ArtistPreReleasesPage />} />
            <Route path="campaigns" element={<CampaignsPage />} />

            {isDigitalCampaignsMediaPlanningEnabled ? (
              <>
                <Route
                  path="campaigns/benchmarks"
                  element={<ArtistBenchmarksPage />}
                />

                <Route
                  path="campaigns/planner"
                  element={<MediaPlannerPage />}
                />
              </>
            ) : null}
          </Route>
          <Route path=":partyId/:familyId" element={<TrackDetailsPage />} />
        </Route>
      </Routes>
    </Suspense>
  );
}

Router.displayName = 'RosterRouter';
